import { render, staticRenderFns } from "./BulkActionArchiveIcon.vue?vue&type=template&id=50b48f9c"
import script from "./BulkActionArchiveIcon.vue?vue&type=script&lang=js"
export * from "./BulkActionArchiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports